import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { Contact } from './Contact';
import { db } from '@heimdall/core-common-client';
import { Loading } from '@heimdall/pwa-core';
import { contexts } from '@heimdall/pwa-core';
import { Network } from '@heimdall/core-domain';
import { Accordion, Box, Layer } from 'grommet';
import { NewContact } from './NewContact';
import { Fab } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { v4 as uuid } from 'uuid';
import { makeStyles, useTheme } from '@material-ui/styles';
var useStyles = makeStyles(function (theme) {
  return {
    fab: {
      position: 'absolute',
      bottom: theme.spacing.unit * 2,
      right: theme.spacing.unit * 2
    }
  };
});
var firestore = db.Firestore.connect().fold(function (err) {
  console.log(err);
  throw err;
}, function (c) {
  return c;
});
export var ContactList = function ContactList() {
  var theme = useTheme();
  var classes = useStyles(theme);
  var firebaseAuthContext = React.useContext(contexts.FirebaseAuthContext);

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      show = _React$useState2[0],
      setShow = _React$useState2[1];

  var createContact =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(event) {
      var potentialContact;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              potentialContact = _objectSpread({}, event.value, {
                id: uuid(),
                created_at: new Date().getTime()
              });

              if (!Network.ContactCodec.is(potentialContact)) {
                _context.next = 7;
                break;
              }

              Object.keys(potentialContact).forEach(function (key) {
                if (potentialContact[key] === undefined) {
                  delete potentialContact[key];
                }
              });
              _context.next = 5;
              return firestore.collection('organizations').doc(firebaseAuthContext.oid).collection('network').doc(potentialContact.id).set(potentialContact, {
                merge: true
              });

            case 5:
              _context.next = 9;
              break;

            case 7:
              console.log('nope');
              console.log(JSON.stringify(potentialContact));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createContact(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var saveData =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(event, contact) {
      var potentialContact;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              potentialContact = _objectSpread({}, event.value, {
                modified_at: new Date().getTime()
              });

              if (!Network.ContactCodec.is(_objectSpread({}, potentialContact, contact))) {
                _context2.next = 7;
                break;
              }

              Object.keys(potentialContact).forEach(function (key) {
                if (potentialContact[key] === undefined && contact[key] === undefined) {
                  delete potentialContact[key];
                }
              });
              _context2.next = 5;
              return firestore.collection('organizations').doc(firebaseAuthContext.oid).collection('network').doc(contact.id).set(potentialContact, {
                merge: true
              });

            case 5:
              _context2.next = 9;
              break;

            case 7:
              console.log('nope');
              console.log(JSON.stringify(_objectSpread({}, event.value, contact)));

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function saveData(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useCollectionData = useCollectionData(firestore.collection('organizations').doc(firebaseAuthContext.oid).collection('network')),
      _useCollectionData2 = _slicedToArray(_useCollectionData, 3),
      data = _useCollectionData2[0],
      loading = _useCollectionData2[1],
      error = _useCollectionData2[2];

  if (loading) {
    return React.createElement(Loading, null);
  }

  if (error) {
    return React.createElement("div", null, "Error ", JSON.stringify(error));
  }

  if (data) {
    var contactList = function contactList() {
      return data.map(function (c) {
        return React.createElement(Contact, {
          save: saveData,
          key: c.id,
          contact: c
        });
      });
    };

    return React.createElement("div", null, React.createElement(Accordion, {
      multiple: false
    }, contactList()), React.createElement(Box, null, show && React.createElement(Box, {
      animation: 'fadeIn'
    }, React.createElement(Layer, {
      onEsc: function onEsc() {
        return setShow(false);
      }
    }, React.createElement(NewContact, {
      cancel: function cancel() {
        setShow(false);
      },
      create: createContact
    })))), React.createElement(Fab, {
      onClick: function onClick() {
        return setShow(true);
      },
      color: 'primary',
      "aria-label": 'Add Contect',
      className: classes.fab
    }, React.createElement(FontAwesomeIcon, {
      icon: ['fas', 'plus'],
      size: '2x'
    })));
  }

  return React.createElement("div", null, "Test");
};